export enum SourceImageType {
  USER = 'USER',
  FARM = 'FARM',
}
export const MAX_BYTE_IMAGE_SIZE = 8388608;
export const ALLOWED_MIME_TYPES = 'image/png, image/jpeg, image/jpg, image/svg';
